module.exports = __webpack_public_path__ + "static/media/chess.fc47850d.svg";